export default "__VITE_ASSET__Br3RYj4g__"